import { observer } from 'mobx-react-lite';

import { ActionText } from '@components/action-text';
import { Card } from '@components/card';
import { Checkbox } from '@components/checkbox';
import { FormLabel } from '@components/form-label';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';
import { IJob, IUser } from 'models/types';

export const CreateUserJobAccessForm = observer(({ user, jobs }: { user: IUser; jobs: IJob[] }) => {
  const { jobStore, t, lang } = useStore();
  const followingAll = jobs.every((job) => user.followingJobs.includes(job.id));
  const followAll = () => jobs.forEach((job) => user.followJob(job.id));
  const unfollowAll = () => jobs.forEach((job) => user.unfollowJob(job.id));
  return (
    <Stack space={2}>
      <Stack space={0} orientation="horizontal" justify="space-between">
        <FormLabel text={t('user.accessform.heading')} />
        <ActionText onClick={followingAll ? unfollowAll : followAll}>
          {followingAll ? t('user.accessform.deselect') : t('user.accessform.select')}
        </ActionText>
      </Stack>
      <Stack space={2}>
        {jobs.map((j) => {
          const isFollowing = user.followingJobs.includes(j.id);
          j.numApplications === 0 && jobStore.loadApplicationCount(j.id);
          const onClick = isFollowing ? () => user.unfollowJob(j.id) : () => user.followJob(j.id);

          return (
            <Card key={j.id} spaceX={4} spaceY={3}>
              <Stack space={0} orientation="horizontal" justify="space-between" align="center">
                <Stack space={3} orientation="horizontal">
                  <Checkbox
                    value={isFollowing}
                    onChange={onClick}
                    labelVisible={false}
                    label="Give access"
                  />
                  <Stack space={0}>
                    <Text text={j.title} font="bold14" />
                    <Text
                      font="regular12"
                      color="purple80"
                      text={`${j.workTypeDisplay(lang)}${j.workTypeDisplay(lang) && ' | '}${
                        j.shortDeadlineDisplay
                      }`}
                    />
                  </Stack>
                </Stack>
                {j.isPublished ? (
                  <Stack space={0} align="center">
                    <Text text={j.numApplications} font="bold14" />
                    <Text
                      text={t('user.accessform.applicants')}
                      font="regular12"
                      color="purple80"
                    />
                  </Stack>
                ) : (
                  <Text text={t('user.accessform.draft')} />
                )}
              </Stack>
            </Card>
          );
        })}
      </Stack>
    </Stack>
  );
});
